var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{on:{"change":_vm.change},model:{value:(_vm.usingPrivateRate),callback:function ($$v) {_vm.usingPrivateRate=$$v},expression:"usingPrivateRate"}})}
var staticRenderFns = []

export { render, staticRenderFns }